import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';


@Component({
  selector: 'app-wizardpage-step14-certifiedexam',
  templateUrl: './wizardpage-step14.component.html',
  styleUrls: ['./wizardpage-step14.component.scss']
})
export class WizardpageStep14CertifiedExamComponent implements OnInit {


  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  initForm: any;
  isfetching: boolean;

  testnow: any[];
  constructor() { }

  @Input() regForm: UntypedFormGroup;



  ngOnInit(): void {

    this.initForm = this.regForm.value;
    this.isfetching = false;

  }


  decreasePage() {
    this.pagecountevnt.emit(0);
  }


  step14Submitted(postValue: UntypedFormGroup) {

    const documentA = this.initForm;
    const documentB = postValue.value;

    this.regForm.get('ExamID').setValue(2);


    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {
      // the is the event property of the template emitting the validation value to the parent component
      this.isfetching = true;
      this.continueevnt.emit(postValue.value);
      this.pagecountevnt.emit(1);

      return true;
    }

   }

   isFetching(e) {
    this.isfetching = e; }

}
